import { useTranslation } from "react-i18next";
import { classNames } from "../../helpers";
import AppButton from "../buttons/AppButton";

type ProgramCardProps = {
  title: string;
  description: string;
  coverImage: string;
  onClick: () => void;
  isAvailable?: boolean;
};
export default function ProgramCard(props: ProgramCardProps) {
  const { title, description, coverImage, onClick, isAvailable } = props;
  const { t } = useTranslation("", {
    keyPrefix: "page.candidate.chooseProgram",
  });
  return (
    <div
      className={classNames(
        "flex flex-col shadow rounded-md overflow-hidden",
        !isAvailable && "opacity-25 cursor-not-allowed"
      )}
    >
      <div className="w-full h-[152px]">
        <img
          src={coverImage}
          alt="program cover image"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="w-full h-full flex flex-col gap-3 p-6 justify-between">
        <div className="flex flex-col gap-1">
          <h3 className="text-lg font-medium text-gray-800">{title}</h3>
          <p className="text-sm font-normal text-gray-400">{description}</p>
        </div>
        <div className="flex justify-end">
          <AppButton
            buttonShape="primary"
            onClick={onClick}
            className={classNames(
              "w-fit",
              !isAvailable && "cursor-not-allowed"
            )}
          >
            {t("register")}
          </AppButton>
        </div>
      </div>
    </div>
  );
}
